import script from "./WeightSummary.vue?vue&type=script&setup=true&lang=js"
export * from "./WeightSummary.vue?vue&type=script&setup=true&lang=js"

import "./WeightSummary.vue?vue&type=style&index=0&id=2dc2d275&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2dc2d275"]])

export default __exports__